module.exports = __webpack_public_path__ + "img/d201211-2.794b2d16.jpg";